import {
    Component,
    EventEmitter,
    Input,
    OnChanges,
    OnInit,
    Output,
    SimpleChanges,
} from '@angular/core';

export enum InputValueState {
    error,
    normal,
    init,
}

type InputValidationEvent = {
    state: InputValueState;
    message: string;
};

@Component({
    selector: 'app-text-input',
    templateUrl: './text-input.component.html',
    styleUrls: ['./text-input.component.scss'],
    standalone: false,
})
export class TextInputComponent implements OnInit, OnChanges {
    readonly ERROR = InputValueState.error;
    readonly NORMAL = InputValueState.normal;
    readonly INIT = InputValueState.init;

    @Input() specialPosition: boolean = false;
    @Input() name: string;
    @Input() label: string;
    @Input() value: string;
    @Input() unit: string = '';
    @Input() inputErrorMessage = '';

    @Output() inputChange = new EventEmitter();

    inputValue = '';
    focus = false;
    inputValueCheck = this.INIT;

    ngOnInit() {
        this.inputValue = this.value;
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes.value && this.value) {
            this.inputValue = this.value;
        }
    }

    inputFocus() {
        this.focus = true;
    }

    inputBlur() {
        this.focus = false;
    }

    onChange(value: string) {
        this.inputChange.emit({ name: this.name, value: value });
    }
}
